var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.872 12.24C5.12533 12.24 4.424 12.1093 3.768 11.848C3.11733 11.5813 2.544 11.192 2.048 10.68C1.55733 10.168 1.17333 9.54133 0.896 8.8C0.618667 8.05333 0.48 7.2 0.48 6.24C0.48 4.98133 0.714667 3.90667 1.184 3.016C1.65333 2.12 2.296 1.43467 3.112 0.959999C3.928 0.48 4.848 0.24 5.872 0.24C7.29067 0.24 8.41333 0.570666 9.24 1.232C10.072 1.888 10.6347 2.81067 10.928 4L8.96 4.312C8.74133 3.62933 8.384 3.08533 7.888 2.68C7.392 2.26933 6.76 2.064 5.992 2.064C5.21867 2.05333 4.576 2.22133 4.064 2.568C3.552 2.91467 3.16533 3.40267 2.904 4.032C2.648 4.66133 2.52 5.39733 2.52 6.24C2.52 7.08267 2.648 7.816 2.904 8.44C3.16 9.05867 3.544 9.54133 4.056 9.888C4.57333 10.2347 5.21867 10.4133 5.992 10.424C6.57333 10.4293 7.08267 10.3253 7.52 10.112C7.95733 9.89333 8.31467 9.56533 8.592 9.128C8.86933 8.68533 9.056 8.13333 9.152 7.472H7.12V5.96H11.2C11.2107 6.04533 11.2187 6.17067 11.224 6.336C11.2293 6.50133 11.232 6.6 11.232 6.632C11.232 7.72 11.016 8.688 10.584 9.536C10.1573 10.3787 9.544 11.04 8.744 11.52C7.944 12 6.98667 12.24 5.872 12.24ZM12.8388 12V0.48H19.7748V2.408H14.7668V5.28H18.8148V7.2H14.7668V12H12.8388Z",
    fill: "#906017"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGf);
export default __webpack_public_path__ + "static/media/GF.9b6e6375cb47b656d9a0e3ca81585339.svg";
export { ForwardRef as ReactComponent };